/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetStockValuesFromDimensionsFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetStockValuesFromDimensionsFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import type { getStockValuesFromDimensions } from '.';

export const getStockValuesFromDimensionsDataMock: GetStockValuesFromDimensionsFragmentFragment = {
  dimensions: [
    {
      type: 'TILES',
      values: [
        {
          availability: {
            state: 'NOT_AVAILABLE',
          },
        },
      ],
    },
    {
      type: 'TILES',
      values: [
        {
          availability: {
            state: 'AVAILABLE',
          },
        },
        {
          availability: {
            state: 'NOT_AVAILABLE',
          },
        },
        {
          availability: {
            state: 'NOT_AVAILABLE',
          },
        },
        {
          availability: {
            state: 'UNSELECTED',
          },
        },
        {
          availability: {
            state: 'NOT_YET_AVAILABLE',
          },
        },
        {
          availability: {
            state: 'AVAILABLE',
          },
        },
      ],
    },
    {
      type: 'INPUT',
      values: [],
    },
  ],
};

export const getStockValuesFromDimensionsResultMock: ReturnType<
  typeof getStockValuesFromDimensions
> = {
  inStock: 3,
  outOfStock: 2,
};

export function getGetStockValuesFromDimensionsFragmentedData(
  data?: GetStockValuesFromDimensionsFragmentFragment,
) {
  return makeFragmentData(
    data || getStockValuesFromDimensionsDataMock,
    GetStockValuesFromDimensionsFragmentFragmentDoc,
  );
}
